export const sizes = {
  mobileXS: '290px',
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  tabletL: '821px',
  laptop: '1024px',
  laptopL: '1440px',
  // desktop: '2560px',
};
